module.exports = __webpack_public_path__ + "static/media/tutorial-treasure-trinket-1.de0c8abf.png";